module.exports = __webpack_public_path__ + "img/32645.905e3121.png";